import type { ReportProvider } from '../types'
export * from './metrics'

// ── Provider registry ─────────────────────────────────────────────────────────
// Single registration point for all workflow report providers.
// Future workflows add exactly one entry here.

const _registry = new Map<string, ReportProvider>()

export const REPORT_PROVIDER_REGISTRY = {
  register(provider: ReportProvider): void {
    _registry.set(provider.id, provider)
  },

  get(id: string): ReportProvider | undefined {
    return _registry.get(id)
  },

  getAll(): ReportProvider[] {
    return [..._registry.values()]
  },

  getByWorkflow(workflowId: string): ReportProvider | undefined {
    return [..._registry.values()].find((p) => p.workflowId === workflowId)
  },

  has(id: string): boolean {
    return _registry.has(id)
  },
} as const
